import React, { CSSProperties, useState } from "react";
import styled from "styled-components";
import { delay } from "../../../util/delay";
import { isNull } from "../../../util/empty_values";
import { IconClose } from "../../icon/IconClose";

const Root = styled.div`
  display: flex;
  align-items: center;
`;

const Input = styled.input`
  border: 1px solid #888;
  border-radius: 0.4rem;
  padding: 0.3rem;
  padding-left: 0.5rem;
  padding-right: 2.2rem;
  width: 100%;
`;

export interface Props {
  onSearch: (term: string, signal: AbortSignal) => void;
  onClear: () => void;
  panelStyle?: CSSProperties;
}

let cancel: () => void | null = null;
let abortController: AbortController | null = null;

export const Search = (props: Props) => {
  const [searchTerm, setSearchTerm] = useState<string>("");

  const runSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchTerm(e.target.value);
    fetchSearch(e.target.value);
  };

  const fetchSearch = (term: string) => {
    if (!isNull(cancel)) {
      cancel();
    }

    if (abortController !== null) {
      abortController.abort();
    }

    cancel = delay({
      action: () => {
        abortController = new AbortController();
        props.onSearch(term, abortController.signal);
      },
      cancel: () => {},
      delayInMs: 250,
    });
  };

  const clearSearch = () => {
    setSearchTerm("");
    props.onClear();
  };

  const iconCloseSize = "1.75rem";
  return (
    <Root style={{ ...props.panelStyle }}>
      <Input placeholder="Search" onChange={runSearch} value={searchTerm} />
      <IconClose
        onClick={clearSearch}
        style={{ width: iconCloseSize, height: iconCloseSize, position: "relative", right: "2rem" }}
      />
    </Root>
  );
};
